<app-form-manager
    *ngIf="params"
    formPlugin="sabentis-person-management-form"
    [params]="params"
    #form>
</app-form-manager>
